<template>
  <ProgressLayout
    v-if="loaded"
    :steps="steps"
    @goToStep="goToStep"
  />
</template>

<script setup>
// @ts-check
import { onMounted, ref } from 'vue';
import {
  onBeforeRouteLeave,
  onBeforeRouteUpdate,
  useRoute,
  useRouter,
} from 'vue-router/composables';

import {
  useEnvelope,
  useEnvelopesProgress,
  // useEnvelopesRoutes,
} from '@/composables/envelopes';

import ProgressLayout from '@/components/layouts/ProgressLayout';

const route = useRoute();
const router = useRouter();
const { envelope } = useEnvelope(route.params.fingerprint);

// const { progressRoute } = useEnvelopesRoutes();
const { steps, stepsRoutes } = useEnvelopesProgress();

const loaded = ref(false);
onMounted(async () => {
  loaded.value = true;
  // allow random routes until stepsProgress implemented
  /** if (progressRoute.value.name !== route.name) {
     await router.replace(progressRoute.value);
  } */
});

onBeforeRouteUpdate((to, __, next) => {
  // allow random routes until stepsProgress implemented
  /** if (!isSent.value && to.name !== progressRoute.value.name) {
    next(progressRoute.value);
  } */

  next();
});

onBeforeRouteLeave((to, __, next) => {
  if (!/^Envelopes(Step|Edit).*$/.test(to.name)) {
    // clear query cache
  }

  next();
});

/** @param {number} step */
function goToStep(step) {
  router.push({
    name: stepsRoutes[step].name,
    params: { fingerprint: envelope.value.fingerprint },
  });
}
</script>
